import React from "react";
import cls from "classnames";
import styles from "./TelephonySection.module.scss";

type Props = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

/**
 * A section for the telephony widget and modal.
 */
export const TelephonySection: React.FC<Props> = (props) => (
  <div {...props} className={cls([props.className, styles.section])}></div>
)